export class InstagramDisconnectModalController {
    static $inject = ['close', 'disconnectPage', '$timeout'];
    constructor(close, disconnectPage, $timeout) {
        'ngInject';
        this.close = close;
        this.disconnectPage = disconnectPage;
        this.$timeout = $timeout;
        this.closeModal = () => {
            this.close();
        };
        this.setDisconnectButtonDisabledStatus = () => {
            this.$timeout(() => {
                this.disconnectButtonDisabled = !this.agreedChecked || !this.motiveInputValue;
            });
        };
        this.motiveInputChange = (event) => {
            this.motiveInputValue = event.detail.value;
            this.setDisconnectButtonDisabledStatus();
        };
        this.agreedCheckChange = (event) => {
            this.agreedChecked = event.detail.checked;
            this.setDisconnectButtonDisabledStatus();
        };
        this.onConfirmDisconnect = async () => {
            if (this.disconnectPage && !this.disconnectButtonDisabled) {
                this.confirmedDisconnection = true;
                this.close();
                await this.disconnectPage(this.motiveInputValue);
            }
        };
        this.onModalChanged = (event) => {
            if (event.detail.modalStatus === 'closed') {
                this.close();
            }
        };
        this.motiveInputValue = '';
        this.agreedChecked = false;
        this.disconnectButtonDisabled = true;
        this.confirmedDisconnection = false;
    }
    $onInit() {
        document
            .getElementById('disconnect-agreed')
            .addEventListener('bdsChange', this.agreedCheckChange);
        document
            .getElementById('disconnect-motive-input')
            .addEventListener('bdsChange', this.motiveInputChange);
        document
            .getElementById('instagram-disconnect-modal')
            .addEventListener('bdsModalChanged', this.onModalChanged);
    }
}
InstagramDisconnectModalController.$inject = ['close', 'disconnectPage', '$timeout'];
